module.exports = __webpack_public_path__ + "media/images/sandbox/print_sheet_opt-82d873594a97144f1da4038c4daa83d2.png";